import styled from 'styled-components';
import { SelectInput } from 'components/common';

export const StyledSelect = styled(SelectInput)`
  && .ant-select-selection-item {
    height: 20px;
    align-items: center;
  }
`;
